module.exports = __webpack_public_path__ + "static/media/61 - Marcos Valle - Estrelar.cf3db722.mp3";